<template>

	<form @submit.prevent="submit">
		<smart-input required label="התחלת זמן שבו יוצג הכדור הזוכה" v-model="form.startRandTime" />
		<smart-input required label="סיום זמן שבו יוצג הכדור הזוכה" v-model="form.endRandTime" />
		<smart-input required label="מספר זוכים" v-model="form.totalCount" />
		<v-select  required item-text="title" item-value="id" :items="lotteries" label="בחר הגרלה" v-model="form.lottery" />
		<v-combobox multiple v-if="lottery" item-text="title" item-value="id" :items="lottery.packages" label="בחר חבילה" v-model="form.package_id"/>
		<v-btn type="submit" color="success">בצע הגרלה</v-btn>
	</form>

</template>

<script>
	import LotteryModule from "src/store/modules/Lottery.module";
	export default {
		name: "lottery-url",
		data(){
			return{
				form:{
					startRandTime:11,
					endRandTime:10,
					totalCount:7,
					lottery:null,
					package_id:[]
				}
			};
		},
		computed:{
			lotteries(){
				return this.$store.state.LotteryModule.lotteries;
			},
			lottery() {
				if (!this.form.lottery) return null;
				return this.lotteries.find(lottery=>lottery.id === this.form.lottery);
			}
		},
		methods:{
			submit(){
				let lottery = this.lotteries.find(lottery=>lottery.id === this.form.lottery);
				this.$emit("change",Object.assign({},this.form,{lottery}));
				this.form.package_id = [];
			}
		},
		watch: {
			"form.lottery": {
				immediate: true,
				async handler() {
					if (this.form.lottery) {
						await this.$store.dispatch(LotteryModule.types.GET, this.form.lottery);
					}
				}
			}

		},
		async created() {
			await this.$store.dispatch(LotteryModule.types.FETCH);
		}
	};
</script>

<style scoped>

</style>
